module.exports = __webpack_public_path__ + "static/img/cellular_automation_rule30_200.cd9ddb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/python/images/cellular_automation_rule30_200.png
// module id = Q+2R
// module chunks = 1